import { Stack, type StackProps } from '@cxnpl/ui';
import type { ReactNode } from 'react';

interface ResponsiveWidthStackProps extends StackProps {
  children?: ReactNode;
}

/**
 * A Stack which changes width based on the device size.
 */
export const ResponsiveWidthStack = ({ children, ...rest }: ResponsiveWidthStackProps) => {
  return (
    <Stack
      flexGrow={1}
      width="100%"
      {...rest}
      $laptop={{
        width: '75%',
        ...rest.$laptop,
      }}
      $desktop={{
        width: '62.5%',
        ...rest.$desktop,
      }}
    >
      {children}
    </Stack>
  );
};
